let language = {
    "A1101P400500": "获取token用户信息失败",
    "A1101B400501": "间隔天数超过最大值和最小值",
    "A1101B400502": "开始日期和间隔天数不能小于当前日期",
    "A1101B400503": "开始日期格式错误",
    "A1101B400504": "间隔天数无效且小于 0",
    "A1101B400505": "不支持的拼单配置类型",
    "A1101B400506": "用户不属于任何合作伙伴",
    "A1101B400507": "该合作伙伴没有店主信息",
    "A1101B400508": "间隔天数为空",

};

export { language }